// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"fadc4ffd","324":"830fbe3a","361":"d1c65206","511":"923ae216","647":"c57fd5d6","665":"013b2d21","687":"e1c416a0","900":"cf44d9b9","930":"96658cf7","946":"99420657","984":"29767514"}[chunkId] + ".chunk.js";
};